"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResponse = void 0;
function isResponse(payload) {
    if (!payload || typeof payload !== 'object') {
        return false;
    }
    return 'data' in payload || 'meta' in payload || 'paging' in payload || 'errors' in payload;
}
exports.isResponse = isResponse;
//# sourceMappingURL=response.js.map